import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Component, Inject} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
@Component({
  selector: 'cm-widget-type-preview-dialog',
  template: `
    <!--<h1 mat-dialog-title>{{data.widgetType.name}}</h1>-->
    <h1 mat-dialog-title class="unit-demo-title">{{data.widgetType.displayName || data.widgetType.content}} </h1>
    <div mat-dialog-content class="unit-demo-wrapper" [ngClass]="data.widgetType.name">
      <iframe [src]="url" width="{{data.widgetType.width}}" height="{{data.widgetType.height}}" (load)="demoLoad()"
              style="border: none"></iframe>
      <mat-spinner [color]="'primary'" [mode]="'indeterminate'" [diameter]="'30'" *ngIf="!demoLoaded"></mat-spinner>
    </div>
    <div *ngIf="data.widgetType._size == 'responsive'" class="mt20 text-right small">
      Click bottom right corner of the unit to resize and see responsive in action.
    </div>
  `,
})
export class WidgetTypePreviewDialogComponent {

  public url;
  public demoLoaded = false;

  constructor(public dialogRef: MatDialogRef<WidgetTypePreviewDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private sanitizer: DomSanitizer) {
    if (data.widgetType.demoUrl) {
      this.url = sanitizer.bypassSecurityTrustResourceUrl(data.widgetType.demoUrl);
    } else {
      console.error('widget does not have demo url');
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  demoLoad() {
    this.demoLoaded = true;
  }
}
